import { Modal, Text, Flex, Button, ThemeIcon } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";

type IntentQuestionnaireCompleteModalProps = {
  opened: boolean;
  onClose: () => void;
};

export default function IntentQuestionnaireCompleteModal({
  opened,
  onClose,
}: IntentQuestionnaireCompleteModalProps) {
  return (
    <Modal opened={opened} onClose={onClose} withCloseButton={false} centered size="sm">
      <Flex direction="column" align="center" py="md">
        <ThemeIcon size={64} radius={64} color="green" variant="light" mb="md">
          <IconCircleCheck size={36} />
        </ThemeIcon>

        <Text fw={600} fz="lg" c="slate.8" mb="xs" ta="center">
          Your onboarding is now complete.
        </Text>

        <Text fz="sm" c="slate.5" ta="center" mb="xl" maw={280}>
          You can now explore Global Opportunities. Good Luck.
        </Text>

        <Button fullWidth onClick={onClose}>
          Got it
        </Button>
      </Flex>
    </Modal>
  );
}
